module.exports = __webpack_public_path__ + "assets/55b880dbfe97105718f1c050ddb17787.jpg";